// Author lidongxu
// Date 2024-02-22 10:53:27

class SithMesStoolPrApplicationTypeConfig {
constructor({
        id = null,
        purchasingType = '',
        itemType = '',
        remark = ''}
= {}) {
    this.id = id;
    this.purchasingType = purchasingType;
    this.itemType = itemType;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesStoolPrApplicationTypeConfig();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.stool.sithMesStoolPrApplicationTypeConfig.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'purchasingType',
        label: 'label.sith.stool.sithMesStoolPrApplicationTypeConfig.grid.purchasingType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'itemType',
        label: 'label.sith.stool.sithMesStoolPrApplicationTypeConfig.grid.itemType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPrApplicationTypeConfig.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    purchasingTypeFilter : '',
    itemTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'purchasingTypeFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationTypeConfig.filter.purchasingType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'itemTypeFilter',
        label: 'label.sith.stool.sithMesStoolPrApplicationTypeConfig.filter.itemType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'purchasingType',
        label: 'label.sith.stool.sithMesStoolPrApplicationTypeConfig.entity.purchasingType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'itemType',
        label: 'label.sith.stool.sithMesStoolPrApplicationTypeConfig.entity.itemType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPrApplicationTypeConfig.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesStoolPrApplicationTypeConfig, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
